import { Link } from 'react-router-dom';
import ArrowIcon from '../../../../../assets/images/catalogue/arrowIcon';
import { IlogisticServiceDetails } from '../../../../../types/services';
import { IlogisticServiceDetailsTab } from './LogisticServiceDetailsTabs/LogisticServiceDetailsTabs';
import LogisticServiceHeaderInformationSection from './LogisticServiceHeaderInformationSection/LogisticServiceHeaderInformationSection';
import { ILogisticServiceHistory } from '../../../../../types/suscription/history.types';

import './LogisticServiceDetailsHeader.scss';

const LogisticServiceDetailsHeader = ({
  logisticServiceData,
  logisticServiceHistoryData,
  handleTabSelectionCallback,
  showSkeletonLoader,
  updateDataCallback,
  updateWithoutLoader
}: {
  logisticServiceData: IlogisticServiceDetails;
  logisticServiceHistoryData: ILogisticServiceHistory[];
  handleTabSelectionCallback: (newTabData: IlogisticServiceDetailsTab) => void;
  showSkeletonLoader: boolean;
  updateDataCallback: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}) => {
  return (
    <div className="LogisticServiceDetailsHeader">
      <Link to="/logistic-service/listing">
        <ArrowIcon className="ArrowIcon" fill="#070F21" style={{ transform: 'rotate(-90deg)' }} />
      </Link>
      <LogisticServiceHeaderInformationSection
        logisticServiceData={logisticServiceData}
        logisticServiceHistoryData={logisticServiceHistoryData}
        handleTabSelectionCallback={handleTabSelectionCallback}
        showSkeletonLoader={showSkeletonLoader}
        updateDataCallback={updateDataCallback}
        updateWithoutLoader={updateWithoutLoader}
      />
    </div>
  );
};

export default LogisticServiceDetailsHeader;
